import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {

        themes: {
            light: {
              primary: '#328DFF',
              primaryLight: '#DBEBFF',
              mbackgroundcolor: '#F9FAFC',
              secondary: '#b0bec5',
              anchor: '#8c9eff',
              anyColor: '#0000ff',
              textcolor: '#333333',
              textcolor6: '#666666',
              textcolor9: '#999999',
              errorlight: '#F8DEDE',
              success: '#8BC34A',
            //   error: '#F8DEDE',
              error: '#D74242',
              errorstrong: '#D74242',
              remindercolor: '#E62E2E',
              tablegray: '#F9FAFC'
            },
        },
      }
});

